import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { useAppStore } from './app/store';
import './index.css';

// Restore the session (httpOnly cookie) before the app decides where to route.
void useAppStore.getState().bootstrap();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
